export enum UserStatus {
  PENDING = 1,
  ACTIVE,
  INACTIVE,
}
